// @flow

import React from "react";
import { Input } from "reactstrap";
import classNames from "classnames";

import PostWidgetChatBubble from "./post-widget-chat-bubble";
import PostWidgetInfoSection from "./post-widget-info-section";
import { BaseInput as BaseInputProps } from "react-jsonschema-form/lib/components/widgets/BaseInput";

type Props = $Exact<{
  ...BaseInputProps,
  options: Object,
}>;

export class FileInputWidget extends React.Component<Props> {
  handleChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const { files } = event.currentTarget;

    if (!files || !files.length) {
      this.props.onChange(undefined);
      return;
    }

    const file = files[0];
    const reader = new FileReader();

    reader.onload = () => {
      const dataURL = String(reader.result);
      const namedDataURL = dataURL.replace(
        ";base64,",
        `;name=${encodeURIComponent(file.name)};base64,`,
      );

      this.props.onChange(namedDataURL);
    };

    reader.readAsDataURL(file);
  };

  handleClick = () => {
    window.open(this.props.value, "_blank");
  };

  render() {
    const options = this.props.options || {};
    const value = this.props.value;
    const props = {
      ...this.props,
      ...options,
      onChange: this.handleChange,
    };

    delete props.readonly;
    delete props.formContext;
    delete props.autofocus;
    delete props.rawErrors;
    delete props.registry;
    delete props.schema;
    delete props.options;
    delete props.label;
    delete props.labelposition;
    delete props.enumOptions;
    delete props.editable;
    delete props.url;
    delete props.value;

    const hasPreviewImg = value && value.startsWith("https:");
    const selectedImagePreview = value && value.startsWith("data:image") ? value : null;
    const previewSrc = selectedImagePreview || options.url || null;

    return (
      <React.Fragment>
        {props.disabled && hasPreviewImg ? (
          <img
            src={value}
            width="200"
            height="148"
            onClick={this.handleClick}
            style={{ cursor: "pointer" }}
          />
        ) : (
          <React.Fragment>
            {previewSrc && (
              <img src={previewSrc} width="200" className="d-block mb-2" alt="preview" />
            )}
            <Input type="file" {...props} className={classNames("mt-1", this.props.className)} />
          </React.Fragment>
        )}
        <PostWidgetChatBubble options={this.props.options} />
        <PostWidgetInfoSection options={this.props.options} />
      </React.Fragment>
    );
  }
}

export default FileInputWidget;
